import { Component } from '@angular/core';
import { json2csv } from 'json-2-csv';
import { DateTime } from 'luxon';
import { UserEffortService } from 'src/app/services/firebase/user-effort.service';
import { UserEvaluationService } from 'src/app/services/firebase/user-evaluation.service';
import { UserTimeService } from 'src/app/services/firebase/user-time.service';
import { UserService } from "src/app/services/firebase/user.service";

@Component({
  selector: 'app-track-progress',
  templateUrl: './track-progress.component.html',
  styleUrls: ['./track-progress.component.scss'],
})
export class TrackProgressComponent {

  constructor(
    private userService: UserService,
    private userEffortService: UserEffortService,
    private userEvaluationService: UserEvaluationService,
    private userTimeService: UserTimeService,
  ) { }

  createBlobLink(name, content: string) {
    if (content.length == 0) return
    const fileContent = content;
    const fileName = name;

    const blob = new Blob([fileContent], { type: 'text/plain' });
    const a = document.createElement('a');
    a.setAttribute('download', fileName);
    a.setAttribute('href', window.URL.createObjectURL(blob));
    a.click();
  }

  downloadData() {
    const subsOne = this.userTimeService.getAll().subscribe(times => {
      subsOne.unsubscribe()
      json2csv(times, (err, csv) => {
        this.createBlobLink('times.csv', csv)
      })
    })

    const subsTwo = this.userEffortService.getAll().subscribe(efforts => {
      json2csv(efforts, (err, csv) => {
        this.createBlobLink('efforts.csv', csv)
      })
    })

    const subsTree = this.userEvaluationService.getAll().subscribe(evaluations => {
      subsTree.unsubscribe()
      json2csv(evaluations, (err, csv) => {
        this.createBlobLink('evaluations.csv', csv)
      })
    })
  }

  getUserList() {
    const subscription = this.userService
      .getAll()
      .subscribe(users => {
        subscription.unsubscribe()
        const commonUsers = users
          .filter(user => !user.admin)
          .map(user => {
            const date = DateTime.fromISO(user.start_at)
            const formattedDate = (date.isValid) ? date.toFormat('yyyy-MM-dd') : ''
            return {
              username: user.username,
              password: user.password,
              training: user.training,
              start_at: formattedDate
            }
          })
        json2csv(commonUsers, (err, csv) => {
          this.createBlobLink('users.csv', csv)
        })
      })
  }

}
